if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        if (document.querySelector('product-bar-form')) {
          this.form.addEventListener('change', this.onChangeHandler.bind(this));
        }
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer') ||
          document.querySelector('cart-popup');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer') || document.querySelector('cart-popup')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }
      updateSubmitButtonStatus(status) {
        const productBarSubmitButton = document.getElementById(`ProductBarSubmitButton-${this.dataset.sectionId}`);

        if (status === 'loading') {
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
          this.querySelector('.loading__spinner').classList.remove('hidden');
          if (productBarSubmitButton) {
            productBarSubmitButton.setAttribute('aria-disabled', true);
            productBarSubmitButton.classList.add('loading');
            productBarSubmitButton.querySelector('.loading__spinner').classList.remove('hidden');
          }
        } else if (status === 'error') {
          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (soldOutMessage) {
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButtonText.classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
          }
          const productBarSoldOutMessage = productBarSubmitButton?.querySelector('.sold-out-message');
          if (productBarSoldOutMessage) {
            productBarSubmitButton.setAttribute('aria-disabled', true);
            productBarSubmitButton.querySelector('span')?.classList?.add('hidden');
            productBarSoldOutMessage.classList.remove('hidden');
          }
        } else if (status === 'finished') {
          this.submitButton.classList.remove('loading');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');

          if (productBarSubmitButton) {
            productBarSubmitButton.classList.remove('loading');
            if (!this.error) productBarSubmitButton.removeAttribute('aria-disabled');
            productBarSubmitButton.querySelector('.loading__spinner').classList.add('hidden');
          }
        }
      }
      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.updateSubmitButtonStatus('loading');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append('sections', [
            formData.get('section-id'),
            ...this.cart.getSectionsToRender().map((section) => section.id),
          ]);
          formData.delete('section-id');
          const parts = window.location.pathname.split('/');
          const pathnames = [];
          if (parts[0] === 'products') {
            pathnames.push(...parts);
          } else {
            let isPush = false;
            for (let i = 0; i < parts.length; i++) {
              if (parts[i] === 'products') {
                isPush = true;
              }
              if (isPush) {
                pathnames.push(parts[i]);
              }
            }
          }

          formData.append('sections_url', `/${pathnames.join('/')}`);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.updateSubmitButtonStatus('error');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              })?.then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure('add:paint-updated-sections', () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure('add:paint-updated-sections', () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            this.updateSubmitButtonStatus('finished');

            CartPerformance.measureFromEvent('add:user-action', evt);
          });
      }

      onChangeHandler(evt) {
        const { name, value } = evt.target;
        const { sectionId } = this.dataset;
        if (name === 'quantity') {
          const quantityInput = document.querySelector(`input[form="product-bar-form-${sectionId}"][name="quantity"]`);
          if (quantityInput && quantityInput.value !== value) {
            quantityInput.value = value;
          }
        }
      }
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

if (!customElements.get('product-bar-form')) {
  customElements.define(
    'product-bar-form',
    class ProductBarForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.form.addEventListener('change', this.onChangeHandler.bind(this));
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );
      }
      onSubmitHandler(evt) {
        evt.preventDefault();
        const { sectionId } = this.dataset;
        const submitButton = document.getElementById(`product-form-${sectionId}`).querySelector('[type="submit"]');
        if (submitButton) {
          submitButton.click();
        }
      }
      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        const { name, value } = target;
        const select = this.querySelector(`select[name="${name}"]`);
        if (select && select.value !== value) {
          select.value = value;
        }
      }

      onChangeHandler(evt) {
        const { name, value } = evt.target;
        const { sectionId } = this.dataset;
        if (name === 'quantity') {
          const quantityInput = document.querySelector(`[form="product-form-${sectionId}"][name="quantity"]`);
          if (quantityInput && quantityInput.value !== value) {
            quantityInput.value = value;
          }
        } else {
          const option = document.querySelector(`[form="product-form-${sectionId}"][name="${name}"][value="${value}"]`);
          if (option && !option.checked) {
            // document.querySelector(`label[for="${option.id}"]`)?.click();
            option.click();
          }
        }
      }
      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      handleErrorMessage(errorMessage = false) {}
    }
  );
}
